(function (window, document) {
  "use strict";

  var DNB = window.DNB;

  // Ortak (her site / her sayfa) init — common.min.js içindedir.
  // ScrollService window "load" üzerinde kendi kendine başlar (_smooth-scroll.js).
  document.addEventListener("DOMContentLoaded", function () {
    DNB.safeInit("Nav", function () { DNB.Nav.init(); });
    DNB.safeInit("Footer", function () { DNB.Footer.init(); });
    DNB.safeInit("Modal", function () { DNB.Modal.init(); });
  });
})(window, document);
